import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  
  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        ></Container>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Noticias TNO: comunicación robusta y efectiva que garantiza credibilidad, objetividad, ética y equilibrio, pilares fundamentales del Periodismo
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El resumen informativo semanal que ofrece la agilidad y el rigor que el mundo digital exige. Un panorama exclusivo de la actualidad que se transmite <strong>totalmente en vivo</strong> a través de nuestro ecosistema global, liderado por una de las voces más respetadas del periodismo en Venezuela.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mb: 2, fontStyle: 'italic' }}
        >
          Noticias TNO: único en su estilo de informar! 🎙️
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 2 }}
        >
          ¿Qué es Noticias TNO? Es nuestra propuesta informativa de vanguardia, diseñada para una audiencia que exige inmediatez y veracidad. Este espacio redefine el periodismo digital al combinar el rigor de la noticia tradicional con la dinámica del streaming y las plataformas sociales. Un análisis completo de la realidad que genera impacto visual y autoridad editorial para las marcas que nos acompañan.
        </Typography>
      </Box>
      
      {/* Sección Sol Vargas */}
      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="/images/solvargas.jpeg"
                alt="Sol Vargas"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: '50%',
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: SOL VARGAS
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              La credibilidad es el activo más valioso de la información
            </Typography>
            <Typography
              variant={'body1'}
              color={'textSecondary'}
              sx={{ mb: 0 }}
            >
              <strong>Sol Vargas</strong> es una figura icónica del Periodismo venezolano, reconocida por su impecable trayectoria en la Dirección de Información en los canales más importantes de Venezuela con una vasta experiencia de 45 años liderando el mundo de las noticias cuyo compromiso con la verdad la convierten en el sello de garantía de <strong>Noticias TNO</strong>. Su voz no sólo informa, otorga prestigio y confianza a cada marca que forma parte de este espacio.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
